import { Dropdown } from 'components/form/inputs/Dropdown'
import { useNodePropertyPanel } from 'features/processFlowDiagrams/components/nodes/propertyPanel/NodePropertyPanelContext'
import {
  FormSection,
  SectionTitle,
} from 'features/processFlowDiagrams/components/nodes/propertyPanel/StylesAndHelper'
import { DatapointSelector } from 'features/systemLens'
import React from 'react'
import { PfdNode } from 'types'

const ENTRY_TYPE_OPTIONS = [
  { label: 'Unit', value: 'unit' },
  { label: 'PFD', value: 'pfd' },
]

/** Entry type, unit selector, and datapoint bindings for the selected node. */
export const LinkSection: React.FC<{ selectedNode: PfdNode }> = ({
  selectedNode,
}) => {
  const {
    selectedEntryType,
    unitOptions,
    selectedTags,
    setSelectedTags,
    siteID,
    setSelectedEntryType,
    handleLinkChange,
    handleDatapointChange,
    isLoadingDatapoints,
    datapoints,
  } = useNodePropertyPanel()

  return (
    <>
      <FormSection>
        <SectionTitle>Link</SectionTitle>
        <Dropdown
          key={`${selectedNode.id}-entry-type`}
          $label='Entry Type'
          options={ENTRY_TYPE_OPTIONS}
          onValueChange={setSelectedEntryType}
          placeholder='Select entry type'
          defaultValue={selectedNode.data.link?.entryType ?? ''}
        />
        {selectedEntryType === 'unit' && unitOptions && (
          <Dropdown
            key={`${selectedNode.id}-unit`}
            $label='Unit'
            options={unitOptions}
            onValueChange={(value) =>
              handleLinkChange({
                entryType: selectedEntryType,
                entryID: value,
                siteID: siteID,
              })
            }
            placeholder='Select unit'
            defaultValue={selectedNode.data.link?.entryID ?? ''}
          />
        )}
      </FormSection>

      {selectedNode.data.link?.entryType === 'unit' && (
        <FormSection>
          <SectionTitle>Bindings</SectionTitle>
          <DatapointSelector
            tagsOptions={datapoints}
            selectedTags={selectedTags}
            setSelectedTags={setSelectedTags}
            isLoadingSensors={isLoadingDatapoints}
            onToggleTags={handleDatapointChange}
            onRemoveTags={handleDatapointChange}
          />
        </FormSection>
      )}
    </>
  )
}
